import { render, staticRenderFns } from "./DropZone.vue?vue&type=template&id=c488469c&scoped=true"
import script from "./DropZone.vue?vue&type=script&lang=ts"
export * from "./DropZone.vue?vue&type=script&lang=ts"
import style0 from "./DropZone.scss?vue&type=style&index=0&id=c488469c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c488469c",
  null
  
)

export default component.exports